import { isAuthenticatedUser } from 'js/lib/user';

export const shouldShowToUBanner = () => {
  return isAuthenticatedUser();
};
